import React from 'react';
import PropTypes from 'prop-types';
import CustomFormBlock from '../../../../../pieces/inputs/formBlock';
import * as allConstants from '../../../../../constants/allConstants';
import {useFormContext} from 'react-hook-form';

const SpotRepairPanel = (props)=> {
  const FIELDS = allConstants.JOB_FIELDS.PLUMBING;
  const subParent = `${FIELDS.REPAIR.api_name}.${FIELDS.SPOT_REPAIR.api_name}`;
  const blockParent = `${props.parent}.${subParent}`;
  const formController = useFormContext();
  const values =formController.getValues()[allConstants.JOB_TYPES.PLUMBING.api_name];

  const getFieldValue = (fieldName)=> {
    const blockValues = values?.[FIELDS.REPAIR.api_name]?.[FIELDS.SPOT_REPAIR.api_name];
    return blockValues?.[fieldName];
  };

  return <>
    <CustomFormBlock{...props}
      field={FIELDS.LENGTH_SPOT_REPAIRS}
      nested={true}
      parent={blockParent}
      defaultValue={getFieldValue(FIELDS.LENGTH_SPOT_REPAIRS.api_name)}
      renderLabel={true}
    />
    <CustomFormBlock{...props}
      field={FIELDS.SIZE_SPOT_REPAIRS}
      nested={true}
      parent={blockParent}
      defaultValue={getFieldValue(FIELDS.SIZE_SPOT_REPAIRS.api_name)}
      renderLabel={true}
    />
    <CustomFormBlock{...props}
      field={FIELDS.SPOT_LOCATION}
      nested={true}
      parent={blockParent}
      defaultValue={getFieldValue(FIELDS.SPOT_LOCATION.api_name)}
      renderLabel={true}
    />
  </>;
};

SpotRepairPanel.propTypes = {
  parent: PropTypes.string.isRequired,
};

export {SpotRepairPanel};
